<cookie-law position="bottom" name="topCookieLaw" expiration="1">
  {{'CORE.COOKIES.this-site' | translate}}
  <a href="{{'cookies' | setDocumentLink : currentLang}}" target="_blank">{{'CORE.COOKIES.cookies' | translate}}</a>
  {{'CORE.COOKIES.agreement' | translate}}
</cookie-law>

